import React from "react";
import { Collapse } from "antd";
import "./faqAccordion.css";

// Each entry maps to one expandable question. `a` may be a single string or an
// array of strings (rendered as separate paragraphs for readability).
const USER_FAQ = [
  {
    q: "What exactly is Talk2Coach?",
    a: "Think of it as your personal hotline to real human expertise. One app, an ever-growing world of topics, live 1:1 video coaching — whenever you need a nudge, a plan, or just someone who gets it. No pre-recorded videos, no generic advice. Just real people, real conversations, real change.",
  },
  {
    q: "What's this going to cost me?",
    a: [
      "It's ₹6.65 per minute, so a full 60-minute session costs ₹399.",
      "You only pay for the time you actually use — no hidden fees, and booking a session is free. Just buy minutes when you need them and use them to talk to your coach.",
    ],
  },
  {
    q: "What if I'm late, or need to cancel or reschedule?",
    a: [
      "If you join a session late, the session will still end at the scheduled time, so your coach can keep to their schedule.",
      "Need to cancel or reschedule? No problem. Just make the change at least 10 minutes before your session and your minutes will stay in your wallet for you to use later.",
    ],
  },
  {
    q: "Okay, but how do I actually find the right coach?",
    a: "Two ways: browse and get inspired, or search with intent. Hit the Explore screen and scroll — something will catch your eye. Or if you already know what you want, just type it in and we'll match you instantly.",
  },
  {
    q: "I've genuinely never done anything like this before. Is that weird?",
    a: "Not even a little. Every single Talk2Coach session starts the same way — your coach wants to know what brought you here today and how they can help. \"I have no idea what I'm doing\" is a perfectly good place to start. That's kind of the whole point.",
  },
  {
    q: "Is this therapy?",
    a: "No — Talk2Coach is coaching, not clinical care. Think growth, guidance, and support, not diagnosis or treatment. If you're going through something serious, we'll always point you toward the right professional or crisis resource instead.",
  },
  {
    q: "How long is a session, really?",
    a: [
      "It depends on what works best for you. You can choose a session length and schedule it at a time that's convenient for you.",
      "Simply check your coach's available time slots, choose one that works for you, and book your session.",
    ],
  },
  {
    q: "How do you make sure the coaches are actually good?",
    a: [
      "We carefully vet every coach before they join Talk2Coach. This includes reviewing their credentials, experience, expertise, and communication skills.",
      "Coaches are approved only for the topics where they have demonstrated genuine expertise, so you can feel confident that you're speaking with someone qualified to help.",
    ],
  },
];

const renderAnswer = (answer) => {
  const paragraphs = Array.isArray(answer) ? answer : [answer];
  return paragraphs.map((text, index) => <p key={index}>{text}</p>);
};

const FaqAccordion = ({ variant = "default" }) => {
  const items = USER_FAQ.map((item, index) => ({
    key: String(index),
    label: item.q,
    children: renderAnswer(item.a),
  }));

  return (
    <section
      className={`faq-section${
        variant === "account" ? " faq-section--account" : ""
      }`}
    >
      <div className="faq-section-title">
        <span className="material-symbols-outlined">live_help</span>
        <h2>FAQ</h2>
      </div>
      <Collapse
        className="faq-collapse"
        accordion={false}
        expandIconPosition="end"
        items={items}
      />
    </section>
  );
};

export default FaqAccordion;
